// * homepage Herosection content

export const HerosectionHeading = "Welcome to Hotel Booking";
export const HerosectionSubHeading = "Find Deals On Hotel";

export const HeroSectioncardData = [
  {
    imageUrl: "./images/imageOne.png",
    firstHeading: "Credit card",
    secondHeading: "Must required",
  },
  {
    imageUrl: "./images/imageTwo.png",
    firstHeading: "Money Back",
    secondHeading: "100% Guarantee",
  },
  {
    imageUrl: "./images/imageThree.png",
    firstHeading: "Best Price",
    secondHeading: "Good Discount",
  },
  {
    imageUrl: "./images/imageFour.png",
    firstHeading: "Customer care",
    secondHeading: "24/7 free Support",
  },
];

//   * Homepage explore section content

export const ExploreSectionHeading = "Explore Nearby";

export const ExploreSectionCardData = [
  {
    imageUrl: "/images/ExploresectionImages/puri-temple.jpg",
    firstHeading: "Puri",
    secondHeading:
      "Puri is a coastal city and a municipality in the state of Odisha in eastern India. It is the district headquarters of Puri district and is situated on the Bay of Bengal, 60 kilometres (37 mi) south of the state capital of Bhubaneswar.",
  },
  {
    imageUrl: "/images/ExploresectionImages/konark-temple.jpg",
    firstHeading: "Konark",
    secondHeading:
      "Konark Sun Temple is a 13th-century CE (year 1250) Sun temple at Konark about 35 kilometres (22 mi) northeast from Puri city on the coastline in Puri district, Odisha, India.The temple is attributed to king Narasimhadeva I of the Eastern Ganga dynasty about 1250 CE",
  },
  {
    imageUrl: "/images/ExploresectionImages/jagganath-puri-temple.jpg",
    firstHeading: "Sri Jagannath Puri Temple",
    secondHeading:
      "The Jagannath Temple is an important Hindu temple dedicated to Jagannath, a form of Vishnu–one of the trinity of supreme divinity in Hinduism. It is located in Puri in the state of Odisha, situated on the eastern coast of India. ",
  },
  {
    imageUrl: "/images/ExploresectionImages/chilika-lake.jpg",
    firstHeading: "Chilika Lake, Puri Beach",
    secondHeading:
      " Chilika Lake is the largest coastal lagoon in India and also the second largest salt water lagoon in the world after the New Caledonian barrier reef in New Caledonia. ",
  },
  {
    imageUrl: "/images/ExploresectionImages/Narendra_Tank.jpg",
    firstHeading: "Narendra Tank",
    secondHeading:
      "The tank was built in 15th century AD by Narendra Dev, who shouldered the responsibility of the kingdom with Purushottama. The tank is spread over a vast area, which features an island in the middle, housing a small temple called Chandana Mandapa which is connected to the southern bank with a bridge. ",
  },
  {
    imageUrl: "/images/ExploresectionImages/lakshmi-temple.jpg",
    firstHeading: "Lakshmi Temple",
    secondHeading:
      "the Lakshmi Temple is a small and beautiful shrine that draws people's attention in large numbers every year due to its historical significance. It features a presiding deity of the goddess Lakshmi who is also considered to be the deity of wealth and happiness.",
  },
];

// * homepage image content section content

export const ImageContentSectionHeading = "Best Hotel For You";
export const ImageContentSectionParagraph =
  "The temple food “Mahaprasad” (not simply prasad) at Puri is held to be of supreme importance. According to Skanda Purana Lord Jagannath redeems the devotees by permitting them to partake His Mahaprasad, to have His darshan and to worship Him by observing rituals and by offering of gifts.";

// * first carausal content

export const CarausalOneData = [
  {
    imgurl: "./images/HomeCarausalOne/c1.png",
    heading: "Out door gateways",
  },
  {
    imgurl:
      "https://a0.muscache.com/im/pictures/1dcef69f-089d-457b-8916-5362867f0068.jpg?im_w=720",
    heading: "Explore The Natrure",
  },
  {
    imgurl:
      "https://a0.muscache.com/im/pictures/miso/Hosting-812489515735850680/original/346a0b04-701f-4188-82f2-b99b6450a1fc.jpeg?im_w=720",
    heading: "Entire Homes",
  },
  {
    imgurl:
      "https://a0.muscache.com/im/pictures/2c334f81-5e21-48fd-b3c0-a9939ab59737.jpg?im_w=720",
    heading: "Unique Stays",
  },
  {
    imgurl:
      "https://a0.muscache.com/im/pictures/miso/Hosting-36171303/original/480ad0ee-cbbe-45e4-893c-dff2fbc45ffd.jpeg?im_w=720",
    heading: "Out door gateways",
  },
  {
    imgurl:
      "https://a0.muscache.com/im/pictures/miso/Hosting-940240916901609633/original/e2c93bdd-23c9-4aab-bbd4-16f9762f96ef.jpeg?im_w=720",
    heading: "pets allowd",
  },
  {
    imgurl:
      "https://a0.muscache.com/im/pictures/224efbf0-afec-4a26-b084-771371252a21.jpg?im_w=720",
    heading: "Entire Homes",
  },
];

// **  instagram card image data

export const InstagramCardData = [
  {
    imgurl:
      "https://a0.muscache.com/im/pictures/hosting/Hosting-4364358/original/c8a5b567-0637-4845-811b-8f656d8f619d.jpeg?im_w=720",
      placename:"Puri"
  },
  {
    imgurl:
      "https://a0.muscache.com/im/pictures/74ebe5c4-037f-4624-b544-195384e15981.jpg?im_w=720",
      placename:"Delhi"
  },
  {
    imgurl:
      "https://a0.muscache.com/im/pictures/miso/Hosting-658296882577751092/original/40c2359d-f25b-4f48-94ce-ee75cab895da.jpeg?im_w=720",
      placename:"Bangalore"
  },
];


//  * footer section content

export const FooterSection_one = "ISKCON Jagannath Puri is India's 2nd Biggets ISKCON Temple.The project will be spread across 22 Acres, with 2,00,000 Sq. ft. of construction which will be built in the Kalinga Architecture style."



export const FooterLiks = [
  {
    name: "About",
    link: "#",
  },
  {
    name: "Contact",
    link: "#",
  },
  {
    name: "Terms & Conditions",
    link: "#",
  },
  {
    name: "Privacy Policy",
    link: "/privacy-policy",
  },
  {
    name: "Blog",
    link: "#",
  },
  {
    name: "FAQ",
    link: "#",
  },
];



export const phoneNumber = "+91 - 6370995573";
export const email = "info@iskconpuri.com"
export const address = "Bhaktivedanta Ashram Sipasirubuli, Puri, Odisha, 752001"
